// Giriş sonrası kullanıcıyı gelmek istediği sayfaya döndürmek için.
//
// OAuth akışlarında kullanıcı siteden çıkıp geri döndüğü için değer
// sessionStorage'da tutulur (aynı sekmede yaşar, sekme kapanınca silinir).

const KEY = 'return_url';

// Yalnızca site içi yollar kabul edilir; açık yönlendirme (open redirect) olmasın
export function isSafePath(value) {
  return typeof value === 'string'
    && value.startsWith('/')
    && !value.startsWith('//')
    && !value.startsWith('/\\');
}

export function saveReturnUrl(value) {
  if (isSafePath(value)) {
    try { sessionStorage.setItem(KEY, value); } catch { /* yok say */ }
  }
}

// Adres çubuğundaki ?returnUrl= varsa kaydeder
export function saveReturnUrlFromSearch(search) {
  try {
    const value = new URLSearchParams(search).get('returnUrl');
    if (value) saveReturnUrl(value);
  } catch { /* yok say */ }
}

// Okur ve siler, tek kullanımlık
export function takeReturnUrl() {
  try {
    const value = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return isSafePath(value) ? value : null;
  } catch {
    return null;
  }
}

// Giriş sonrası gidilecek yol: hedef varsa oraya, profil eksikse profile
export function postLoginPath(candidateId) {
  const target = takeReturnUrl();
  if (!candidateId) return '/panel/profil';
  return target || '/panel';
}
